export enum CompletionType {
  Quantity = 'Quantity',
  Load = 'Load'
}
